import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthGateway } from '../application/gateway/AuthGateway';
import { StockColumn } from '../domain/models/PalletStock';
import { Lang } from '../ui/util/langs';

@Pipe({
  name: 'stockColumnDesc'
})
export class StockColumnDescPipe implements PipeTransform {

    constructor(private _authService: AuthGateway, public translate: TranslateService) {
    }

  transform(stockColumn: StockColumn | undefined | null): string {
    if(!stockColumn)
        return this.translate.instant('CommonLabels.NotAvailableLabel')

    let lang = Lang.ENGLISH;

    const profile = this._authService.getUser()
    if(profile)
    {
      lang = profile.lang;
    }else{
      lang = this.translate.currentLang;
    }

    switch(lang)
    {
      case Lang.ENGLISH:
        return !stockColumn.isPackingList ? stockColumn.columnName :   stockColumn.columnName + " (Packing List)";
      case Lang.SPANISH:
        return !stockColumn.isPackingList ? stockColumn.columnNameEs : stockColumn.columnNameEs + " (Packing List)";
      default:
        return !stockColumn.isPackingList ? stockColumn.columnName :   stockColumn.columnName + " (Packing List)";
    }
  }



}
